import { nullToZero } from 'src/app/shared/helpers/shared-zero-to-null.function';
import { ExtRfrMonStacksQueryI } from './rfr-mon-stacks.query.ext';
import { RfrMonStacksQueryI } from './rfr-mon-stacks.query.int';
import { ExtRfrMonStacksI } from './rfr-mon-stacks.result.ext';
import { RfrMonStacksResponseI } from './rfr-mon-stacks.result.int';

export const MapRfrMonStacks = {
    mapQuery: (int: RfrMonStacksQueryI): ExtRfrMonStacksQueryI => ({
      request: { stackCode: int.stackCode }
    }),
    mapResult: (ext: ExtRfrMonStacksI): RfrMonStacksResponseI => {
      return {
        locations: ext.response.response.tt_location?.tt_location.map(location => ({
          location: location.location,
          done: nullToZero(location.nr_done),
          todo: nullToZero(location.nr_todo),
          total: nullToZero(location.nr_done) + nullToZero(location.nr_todo),
          percentage: Math.ceil(100 * (nullToZero(location.nr_done) / (nullToZero(location.nr_done) + nullToZero(location.nr_todo)))),
        }))
      };
    },
};
